exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-navigation-drawer[data-v-361e0abc]{z-index:10!important}", ""]);

// exports
